import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import { AgentContactInfosDto, AgentContactInfosUpdateDto, AgentProfileDto } from '@workspace/data-types';
import { AuraEditWrapperComponent } from '@workspace/ng-aura';
import { AgentContactInfosDisplayComponent } from '../display/agent-contact-infos-display.component';
import { AgentContactInfosFormComponent } from '../form/agent-contact-infos-form.component';

@Component({
  selector: 'etxe-agent-contact-infos-edit',
  imports: [AuraEditWrapperComponent, AgentContactInfosFormComponent, AgentContactInfosDisplayComponent],
  templateUrl: './agent-contact-infos-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentContactInfosEditComponent {
  readonly initialProfile = input<AgentProfileDto | null>(null);
  readonly initialContactInfos = input<AgentContactInfosDto | undefined>(undefined);
  readonly isEditing = model<boolean>(false);
  readonly isAllowedToEdit = input<boolean>(true);

  readonly saved = output<AgentContactInfosUpdateDto>();
  readonly profileSaved = output<AgentProfileDto>();

  readonly currentContactInfos = computed<AgentContactInfosDto | undefined>(() => {
    return this.initialContactInfos() ?? this.initialProfile()?.settings?.contactInfos;
  });

  onSave(dto: AgentContactInfosUpdateDto | null): void {
    if (!dto) return;
    this.saved.emit(dto);
    const profile = this.initialProfile();
    if (profile) {
      this.profileSaved.emit({
        ...profile,
        settings: {
          ...profile.settings,
          contactInfos: dto.contactInfos,
        },
      });
    }
  }
}
